export default __webpack_public_path__ + "static/media/vdt2.90e98b01.png";